import React from "react";
import {connect} from "react-redux";
import {DEFAULT_PER_PAGE} from "../../config";
import {Button, Col, Row, Table, Tooltip} from "antd";
import {loadCompanyLogs} from "../../actions/account";
import {updatePage} from "../../actions/page";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import {displayErrors} from "../../libs/utils";
import {DateTimeFormat} from "../shared/DateTimeFormat";
import AccessGate from "../permissions/AccessGate";

class CompanyLog extends React.Component {
    state = {
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true },
        logs: [],
        loadingLogs: true
    };

    componentDidMount() {
        this.loadLogs();
    }

    loadLogs(page = null, per_page = null) {
        if(page == null) {
            page = this.state.pagination.current;
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loadingLogs: true });

        this.props.loadCompanyLogs(this.props.companyGuid, page, per_page, null, (res) => {
            this.setState({ logs: res.data.data, loadingLogs: false, pagination:
                    { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true }});
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loadingLogs: false });
                displayErrors(err.response.data);
            }
        });
    }

    changePage(data) {
        this.loadLogs(data.current, data.pageSize);
    }

    parseLog(row) {
        let data = [];

        let name = '';

        if(row.actor === null) {
            name = 'System';
        } else {
            name = row.actor.first_name;

            if(row.actor.last_name !== null) {
                name += ' ' + row.actor.last_name;
            }

            if(row.actor.user_type === 'API_USER') {
                name += ' (API)'
            }
        }

        data.push(name);
        data.push(row.verb);

        if(row.action_object !== null) {
            if(row.action_object_type === 'domain') {
                data.push(row.action_object.domain);
            } else if(row.action_object_type === 'user') {
                let name = row.action_object.first_name;

                if(row.action_object.last_name!== null) {
                    name += ' ' + row.action_object.last_name;
                }

                data.push(name);
            } else if(row.action_object_type === 'group') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'website_setup_order' || row.action_object_type === 'i_p_address_order' || row.action_object_type === 'shared_hosting_order') {
                data.push('#' + row.action_object.id);
            } else if(row.action_object_type === 'invoice') {
                data.push('#' + row.action_object.id);
            } else if(row.action_object_type === 'payment_method') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'hosting_account') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'shared_hosting_account') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'firewall_rule' || row.action_object_type === 'firewall_ruleset' || row.action_object_type === 'firewall_policy') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'software_preset') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'allocated_i_p') {
                data.push(row.action_object.ip_address);
            } else if(row.action_object_type === 'email_address') {
                data.push(row.action_object.address);
            } else if(row.action_object_type === 'a_p_i_key') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'contact') {
                data.push(row.action_object.first_name + ' ' + row.action_object.last_name);
            } else if(row.action_object_type === 'content_writer_article') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'content_writer_project') {
                data.push(row.action_object.name);
            } else if(row.action_object_type === 'webhook') {
                data.push('"' + row.action_object.name + '"');
            }
        }

        if(row.action_object_type !== null) {
            if(row.action_object_type === 'software_installation') {
                data.push('(' + row.action_object.name + ')')
            }
        }

        if(row.target!== null) {
            if(row.target_type === 'domain') {
                data.push('for');
                data.push(row.target.domain);
            } else if(row.target_type === 'hosting_account') {
                data.push('for');
                data.push(row.target.name);
            } else if(row.target_type === 'shared_hosting_account') {
                data.push('for');
                data.push(row.target.name);
            } else if(row.target_type === 'firewall_rule' || row.target_type === 'firewall_ruleset' || row.target_type === 'firewall_policy') {
                data.push('for');
                data.push(row.target.name);
            } else if(row.target_type === 'allocated_i_p') {
                data.push('for');
                data.push(row.target.ip_address);
            } else if(row.target_type === 'invoice') {
                data.push('for');
                data.push('#' + row.target.id);
            } else if(row.target_type === 'content_writer_article') {
                data.push('for');
                data.push(row.target.name);
            } else if(row.target_type === 'content_writer_project') {
                data.push('from');
                data.push(row.target.name);
            } else if(row.target_type === 'company') {
                data.push('of');
                data.push(row.target.name);
            }
        }

        return data.join(' ');
    }

    render() {
        const columns = [
            { title: 'Timestamp', dataIndex: 'date_created', key: 'timestamp', render: (item) => <DateTimeFormat value={item} /> },
            { title: 'IP Address', dataIndex: 'ip_address', key: 'ip_address' },
            { title: 'Useragent', dataIndex: 'user_agent', key: 'user_agent', render: (item) => item || '-' },
            { title: 'Action', key: 'action', width: '40%', render: (item, row) => this.parseLog(row)}
        ];

        return(
            <AccessGate scopes={['can_view_company_logs']}>
                <Row justify='end' style={{marginBottom: '10px'}}>
                    <Col><Tooltip title='Reload table'><Button type='text' icon={<UndoOutlined/>}
                                                               onClick={() => this.loadLogs()}/></Tooltip></Col>
                </Row>
                <div style={{overflowX: 'auto'}}>
                    <Table
                        columns={columns}
                        rowKey={(item) => item.guid}
                        dataSource={this.state.logs}
                        loading={this.state.loadingLogs}
                        pagination={this.state.pagination}
                        onChange={(e) => this.changePage(e)}
                    />
                </div>
            </AccessGate>
    );
    }
    }

    export default connect(null, { updatePage, loadCompanyLogs })(CompanyLog);